import React from "react";
import { Link } from "react-router-dom";
import ProgressBar from "./ProgressBar";
import defaultAvatar from "../assets/BBall@2x.png";

export default function PlayerCard({ player, fundraiserClosed, displayMode = "individual" }) {
  const pct = Math.round((player.raised / player.goal) * 100);
  const goalMet = player.raised >= player.goal;
  const photo = player.photo_url || defaultAvatar;
  const hasPhoto = !!player.photo_url;
  const isTeamMode = displayMode === "team";

  return (
    <div className="bg-white rounded-xl border border-warm-gray p-6 flex flex-col items-center text-center shadow-sm hover:shadow-md transition-shadow relative">
      {/* Goal Met badge — only in individual mode */}
      {goalMet && !isTeamMode && (
        <div className="absolute -top-2 -right-2 bg-green-500 text-white text-[10px] font-bold px-2.5 py-1 rounded-full shadow-sm">
          Goal Met!
        </div>
      )}

      {/* Avatar */}
      <div className="w-16 h-16 rounded-full bg-navy overflow-hidden mb-3">
        <img
          src={photo}
          alt={player.name}
          className={`w-full h-full ${hasPhoto ? "object-cover" : "object-contain p-2 invert"}`}
        />
      </div>

      {/* Name & Number */}
      <h3 className="font-display text-lg font-bold text-navy">
        {player.name}
      </h3>
      <span className="text-sm text-navy/50 font-medium mb-3">
        #{player.number}
      </span>

      {/* Progress — only in individual mode */}
      {!isTeamMode && (
        <>
          <div className="w-full mb-1">
            <ProgressBar raised={player.raised} goal={player.goal} size="sm" />
          </div>
          <p className="text-xs text-navy/60 mb-4">
            <span className="font-semibold text-black">{pct}%</span> of $
            {player.goal} goal
          </p>
        </>
      )}

      {/* CTA */}
      <Link
        to={`/player/${player.id}`}
        className={`w-full inline-block text-center text-sm font-semibold py-2.5 px-4 rounded-lg transition-colors ${
          fundraiserClosed
            ? "bg-warm-gray text-navy/40 pointer-events-none"
            : "bg-navy text-white hover:bg-navy-light"
        } ${isTeamMode ? "mt-1" : ""}`}
      >
        {fundraiserClosed ? "Fundraiser Closed" : `Donate for ${player.name}`}
      </Link>
    </div>
  );
}
